module.exports = __webpack_public_path__ + "img/banner13-3@2x.2bb63e75.jpg";